import React, { useState } from 'react'
import { useToastDispatchContext } from './layouts/toast/context/toastContext';
import { useEffect } from 'react';

const isJavaScript = (content) => {
    const jsRegex = /function\s*\w*\s*\(|\w+\s*=\s*function\s*\(|\(\s*function\s*\(|console\..*;/;
    return jsRegex.test(content);
}

const isScriptExist = () =>
    new Promise((resolve) => {
        const scripts = [...document.getElementsByTagName("script")];

        // Cherche un script type module ou defer
        const mainScript = scripts.find((s) => s.type === "module" || s.defer);

        // Si on n’a rien trouvé, on assume que le script existe pour ne pas bloquer
        if (!mainScript || !mainScript.src) {
            resolve(true);
            return;
        }

        const url = mainScript.src;
        const headers = new Headers();
        headers.append("pragma", "no-cache");
        headers.append("cache-control", "no-cache");

        fetch(url, { method: "get", headers })
            .then((res) => res.text())
            .then((content) => resolve(isJavaScript(content)))
            .catch(() => resolve(true));
    });
const Updater = (props) => {
    const channel = new BroadcastChannel('reloadChannel');
    const [isToast, setIsToast] = useState(0);
    const toast = useToastDispatchContext();

    const reload = (event) => {
        if (!event.data || event.data.command !== 'reload') {
            return;
        }
        window.location.reload();
    }

    const check = async () => {
        if (isToast == 1) {
            return;
        }
        const isExist = await isScriptExist()
        if (isExist) {
            return;
        }
        setIsToast(1);
    }

    useEffect(() => {
        check();
        const intervalId = setInterval(async () => await check(), 60000)
        channel.addEventListener('message', reload);
        return () => {
            channel.close();
            clearInterval(intervalId);
        }
    }, []);

    useEffect(() => {
        if (isToast == 0 || isToast == 2) return;
        toast.info('New Talkr version available !', <span onClick={() => channel.postMessage({ command: 'reload' })} style={{ fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}>To update the platform, click here 👈</span>, 5000, 0);
    }, [isToast]);
}

export default Updater